import PropTypes from 'prop-types';

function MMHomeInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M2.53862 11.3531C2.24558 14.3794 1.94722 22.723 2.53862 24.9661C2.69846 25.5629 27.3031 26.0317 27.2765 24.9661C27.09 17.2778 27.2765 8.7584 27.2765 8.7584C27.2765 8.7584 2.23493 6.80302 2.26157 8.2256C2.28821 9.64817 2.53862 11.3531 2.53862 11.3531Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.10085 7.71924C8.11923 8.19006 8.04237 8.65976 7.87486 9.10016C7.70736 9.54057 7.45267 9.94263 7.12606 10.2822C6.79944 10.6219 6.40762 10.892 5.97409 11.0766C5.54055 11.2611 5.07421 11.3563 4.60303 11.3563C4.13184 11.3563 3.66551 11.2611 3.23197 11.0766C2.79843 10.892 2.40661 10.6219 2.08 10.2822C1.75338 9.94263 1.49869 9.54057 1.33119 9.10016C1.16369 8.65976 1.08682 8.19006 1.1052 7.71924H8.10085Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.2188 7.71924C15.2371 8.19006 15.1603 8.65976 14.9928 9.10016C14.8253 9.54057 14.5706 9.94263 14.244 10.2822C13.9174 10.6219 13.5255 10.892 13.092 11.0766C12.6585 11.2611 12.1921 11.3563 11.7209 11.3563C11.2498 11.3563 10.7834 11.2611 10.3499 11.0766C9.91635 10.892 9.52453 10.6219 9.19792 10.2822C8.8713 9.94263 8.61661 9.54057 8.44911 9.10016C8.28161 8.65976 8.20474 8.19006 8.22312 7.71924H15.2188Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.22 7.71924C22.22 8.64763 21.8512 9.53799 21.1947 10.1945C20.5382 10.8509 19.6479 11.2197 18.7195 11.2197C17.7911 11.2197 16.9007 10.8509 16.2443 10.1945C15.5878 9.53799 15.219 8.64763 15.219 7.71924H22.22Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.125 7.84717C29.125 8.77555 28.7562 9.66592 28.0997 10.3224C27.4433 10.9789 26.5529 11.3477 25.6245 11.3477C24.6961 11.3477 23.8058 10.9789 23.1493 10.3224C22.4928 9.66592 22.124 8.77555 22.124 7.84717H29.125Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.13833 0.398682C3.88625 0.760985 0.604214 7.7886 1.16898 7.78327C4.62684 7.7513 29.3327 8.76362 29.1089 7.78327C28.7573 6.22217 26.9298 0.93148 25.1396 0.750329C23.3494 0.569177 5.13833 0.398682 5.13833 0.398682Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.99262 25.4135L12.8534 25.5787C12.8534 25.5787 12.9227 17.2883 12.8534 16.2973C12.6989 13.9477 7.89838 13.3562 7.21107 16.0416C6.94467 18.924 6.99262 25.4135 6.99262 25.4135Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M23.1416 15.3863C22.7527 15.3863 17.2809 14.9334 16.9612 15.3171C16.6415 15.7007 16.2792 19.9418 16.9612 20.1762C17.6432 20.4106 23.1843 20.8155 23.44 20.1762C23.6958 19.5368 24.2872 15.4449 23.1416 15.3863Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path d="M8.12744 8.15623L11.0099 0.398682" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M15.219 8.46538L15.528 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M22.1241 8.52399L20.2007 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
        </svg>
    );
}

export default MMHomeInactive;

MMHomeInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMHomeInactive.defaultProps = {
    className: null,
    width: 28,
};
